import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { RouterProvider } from 'react-router/dom';
import { AuthProvider } from './features/auth/AuthProvider.tsx';
import { router } from './router.tsx';
import { NoticesProvider } from './ui/NoticesProvider.tsx';

export function AppProviders({ children }: { children: ReactNode }) {
  // Sin reintentos automáticos de escrituras; las lecturas reintentan una vez.
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000 }, mutations: { retry: 0 } } }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <NoticesProvider>
        <AuthProvider>{children}</AuthProvider>
      </NoticesProvider>
    </QueryClientProvider>
  );
}

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
